import useAvaturnHelperDefault from '@features/avaturn/hooks/useAvaturnHelper';
import useUserProfileHelperDefault from '@features/avaturn/hooks/useUserProfileHelper';
import useClientHandleWebsocketMsgDefault from '@core/dashboard/hooks/useHandleWebsocketMsg';

export const useAvaturnHelper = useAvaturnHelperDefault;
export const useUserProfileHelper = useUserProfileHelperDefault;

export const useClientHandleWebsocketMsg = useClientHandleWebsocketMsgDefault;
